import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "s20 widget shadow-100 px-5 py-4 text-center"
}
const _hoisted_2 = {
  key: 1,
  class: "s20 widget shadow-100 px-5 py-4 text-center"
}
const _hoisted_3 = { class: "font-semibold text-xl" }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 0,
  class: "s20 widget shadow-100 pb-1"
}
const _hoisted_6 = { class: "mt-6 ml-4 mb-5 collapse-open active" }
const _hoisted_7 = { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }
const _hoisted_8 = { class: "s20 pb-7 collapse-content active" }
const _hoisted_9 = { class: "container-full-2 s20 mb-5" }
const _hoisted_10 = { class: "s7" }
const _hoisted_11 = { class: "font-semibold mt-3" }
const _hoisted_12 = { class: "table separator skin1 sm selection text-right" }
const _hoisted_13 = { class: "font-semibold pr-5" }
const _hoisted_14 = { class: "font-semibold text-red pr-5" }
const _hoisted_15 = { class: "font-semibold pr-5" }
const _hoisted_16 = { class: "font-semibold text-red pr-5" }
const _hoisted_17 = { class: "font-semibold text-red pr-5" }
const _hoisted_18 = { class: "font-semibold pr-5" }
const _hoisted_19 = { class: "font-semibold pr-5" }
const _hoisted_20 = { class: "text-lg font-semibold text-red pr-5" }
const _hoisted_21 = { class: "text-lg font-semibold text-red pr-5" }
const _hoisted_22 = { class: "font-semibold pr-5" }
const _hoisted_23 = { class: "font-semibold text-red pr-5" }
const _hoisted_24 = { style: {"background-color":"#e7ffd6"} }
const _hoisted_25 = { class: "font-semibold text-blue pr-5" }
const _hoisted_26 = { style: {"background-color":"#eefde3"} }
const _hoisted_27 = { class: "text-lg font-semibold text-green pr-5" }

import { reactive, ref, onMounted, computed, PropType } from "vue";
import { formatAmount, MONTHS_FR } from "@/utils";
import axios from "axios";
import moment from "moment";

interface PlanMensuel {
    columns: string[];
    data: {
        _DECAISSEMENT_: number[],
        _FOND_RISQUE_: number[],
        _CREDITS_MENSUELS_: number[],
        _FRAIS_MENSUELS_: number[],
        _RENFOUREMENT_: number[],
        _REVOLVING_: number[],
        _CASHBACK_TVA_: number[],
        _UTILISATION_: number[],
        _UTILISATION_INDEX_: number[],
        _UTILISATION_CUMUL_: number[],
        _DEPENSES_MENSUELS_: number[],
        _CREDIT_EPARGNE_: number[],
        _SOLDE_TOTAL_CASHFLOW_: number[],
        _UTILISATION_BY_INDEX_: number[],
        _PROGRESSIVE_: number[],
    };
    totals: {
        _DECAISSEMENT_: number,
        _FOND_RISQUE_: number,
        _CREDITS_MENSUELS_: number,
        _FRAIS_MENSUELS_: number,
        _RENFOUREMENT_: number,
        _REVOLVING_: number,
        _CASHBACK_TVA_: number,
        _UTILISATION_: number,
        _UTILISATION_INDEX_: number,
        _UTILISATION_CUMUL_: number,
        _DEPENSES_MENSUELS_: number,
        _CREDIT_EPARGNE_: number,
        _SOLDE_TOTAL_CASHFLOW_: number,
        _UTILISATION_BY_INDEX_: number,
        _PROGRESSIVE_: number,
    };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UserPlanMensuel',
  props: {
    planMensuel: {},
    title: {}
  },
  setup(__props: any) {

// @ts-expect-error raison: lib externe mal typée
const props = __props;
const loading = ref(false);
const error = ref(null as string | null);

/*const title = computed(() => {
    if (!props.dateDebut || !props.dateFin) { return ''; }
    const dateDebutM = moment(props.dateDebut);
    const dateFinM = moment(props.dateFin);

    return `Année ${(props.offset + 1)} / ${MONTHS_FR[dateDebutM.month()]} ${dateDebutM.format('YYYY')} - ${MONTHS_FR[dateFinM.month()]} ${dateFinM.format('YYYY')}`;
});*/


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("span", { class: "font-semibold text-xl" }, " Chargement des données... ", -1)
          ]))]))
        : (!_ctx.planMensuel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(error.value ?? 'Aucun plan mensuel disponible'), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.planMensuel.data)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, [
                        _cache[1] || (_cache[1] = _createElementVNode("img", {
                          src: "/icons/icon-panel-open.svg",
                          class: "size-xs icon-neutral mr-2 collapse-icon-open",
                          alt: ""
                        }, null, -1)),
                        _cache[2] || (_cache[2] = _createElementVNode("img", {
                          src: "/icons/icon-panel-close.svg",
                          class: "size-xs icon-neutral mr-2 collapse-icon-close",
                          alt: ""
                        }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(props.title), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("h4", _hoisted_11, _toDisplayString(_ctx.title), 1)
                        ]),
                        _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"s13 flex gap-2 justify-content-right\"><button class=\"btn black normal justify-content-center mx-0 btn-filtre\"><img src=\"/icons/icon-pdf.svg\" class=\"btn-icon\" alt=\"\"><span>Exporter PDF</span></button><button class=\"btn black normal justify-content-center mx-0 btn-filtre\"><img src=\"/icons/icon-excel.svg\" class=\"btn-icon\" alt=\"\"><span>Exporter Excel</span></button></div>", 1))
                      ]),
                      _createElementVNode("table", _hoisted_12, [
                        _createElementVNode("thead", null, [
                          _cache[6] || (_cache[6] = _createElementVNode("tr", null, [
                            _createElementVNode("th"),
                            _createElementVNode("th", null, "1"),
                            _createElementVNode("th", null, "2"),
                            _createElementVNode("th", null, "3"),
                            _createElementVNode("th", null, "4"),
                            _createElementVNode("th", null, "5"),
                            _createElementVNode("th", null, "6"),
                            _createElementVNode("th", null, "7"),
                            _createElementVNode("th", null, "8"),
                            _createElementVNode("th", null, "9"),
                            _createElementVNode("th", null, "10"),
                            _createElementVNode("th", null, "11"),
                            _createElementVNode("th", null, "12"),
                            _createElementVNode("th", { class: "font-semibold pr-5" }, "Total")
                          ], -1)),
                          _createElementVNode("tr", null, [
                            _cache[4] || (_cache[4] = _createElementVNode("th", { class: "mode text-left py-5 pl-5" }, "Mois", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planMensuel.columns, (column, index) => {
                              return (_openBlock(), _createElementBlock("th", { key: index }, _toDisplayString(column), 1))
                            }), 128)),
                            _cache[5] || (_cache[5] = _createElementVNode("th", { class: "font-semibold pr-5" }, null, -1))
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _cache[7] || (_cache[7] = _createElementVNode("td", { class: "mode text-left pl-5" }, "Décaissement", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planMensuel.data['_DECAISSEMENT_'], (data, index) => {
                              return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(_unref(formatAmount)(data)), 1))
                            }), 128)),
                            _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(formatAmount)(_ctx.planMensuel['totals']['_DECAISSEMENT_'])), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[8] || (_cache[8] = _createElementVNode("td", { class: "mode text-left pl-5" }, "25% Fond de risque", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planMensuel.data['_FOND_RISQUE_'], (data, index) => {
                              return (_openBlock(), _createElementBlock("td", {
                                class: "text-red",
                                key: index
                              }, _toDisplayString(_unref(formatAmount)(data)), 1))
                            }), 128)),
                            _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(formatAmount)(_ctx.planMensuel['totals']['_FOND_RISQUE_'])), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[9] || (_cache[9] = _createElementVNode("td", { class: "mode text-left pl-5" }, "Crédits Mensuels", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planMensuel.data['_CREDITS_MENSUELS_'], (data, index) => {
                              return (_openBlock(), _createElementBlock("td", {
                                class: "",
                                key: index
                              }, _toDisplayString(_unref(formatAmount)(data)), 1))
                            }), 128)),
                            _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(formatAmount)(_ctx.planMensuel['totals']['_CREDITS_MENSUELS_'])), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[10] || (_cache[10] = _createElementVNode("td", { class: "mode text-left pl-5" }, "Frais mensuels: 3%", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planMensuel.data['_FRAIS_MENSUELS_'], (data, index) => {
                              return (_openBlock(), _createElementBlock("td", {
                                class: "text-red",
                                key: index
                              }, _toDisplayString(_unref(formatAmount)(data)), 1))
                            }), 128)),
                            _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(formatAmount)(_ctx.planMensuel['totals']['_FRAIS_MENSUELS_'])), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[11] || (_cache[11] = _createElementVNode("td", { class: "mode text-left pl-5" }, "Remboursement: 50%", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planMensuel.data['_RENFOUREMENT_'], (data, index) => {
                              return (_openBlock(), _createElementBlock("td", {
                                class: "text-red",
                                key: index
                              }, _toDisplayString(_unref(formatAmount)(data)), 1))
                            }), 128)),
                            _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(formatAmount)(_ctx.planMensuel['totals']['_RENFOUREMENT_'])), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[12] || (_cache[12] = _createElementVNode("td", { class: "mode text-left pl-5" }, "Revolving Recharge", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planMensuel.data['_REVOLVING_'], (data, index) => {
                              return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(_unref(formatAmount)(data)), 1))
                            }), 128)),
                            _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(formatAmount)(_ctx.planMensuel['totals']['_REVOLVING_'])), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[13] || (_cache[13] = _createElementVNode("td", { class: "mode text-left pl-5" }, "Cash-Back TVA", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planMensuel.data['_CASHBACK_TVA_'], (data, index) => {
                              return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(_unref(formatAmount)(data)), 1))
                            }), 128)),
                            _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(formatAmount)(_ctx.planMensuel['totals']['_CASHBACK_TVA_'])), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[14] || (_cache[14] = _createElementVNode("td", { class: "text-lg font-semibold py-5 text-left pl-5" }, "Utilisation", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planMensuel.data['_UTILISATION_'], (data, index) => {
                              return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(_unref(formatAmount)(data)), 1))
                            }), 128)),
                            _createElementVNode("td", _hoisted_20, _toDisplayString(_unref(formatAmount)(_ctx.planMensuel['totals']['_UTILISATION_'])), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[15] || (_cache[15] = _createElementVNode("td", { class: "font-bold text-left pl-5" }, "Index Utilisation", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planMensuel.data['_UTILISATION_INDEX_'], (data, index) => {
                              return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(_unref(formatAmount)(data)), 1))
                            }), 128)),
                            _createElementVNode("td", _hoisted_21, _toDisplayString(_unref(formatAmount)(_ctx.planMensuel['totals']['_UTILISATION_INDEX_'])), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[16] || (_cache[16] = _createElementVNode("td", { class: "font-bold text-left pl-5" }, "Index Cumulé", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planMensuel.data['_UTILISATION_CUMUL_'], (data, index) => {
                              return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(_unref(formatAmount)(data)), 1))
                            }), 128)),
                            _createElementVNode("td", _hoisted_22, _toDisplayString(_unref(formatAmount)(_ctx.planMensuel['totals']['_UTILISATION_CUMUL_'])), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[17] || (_cache[17] = _createElementVNode("td", { class: "mode text-left pl-5" }, "Depenses Mensuels", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planMensuel.data['_DEPENSES_MENSUELS_'], (data, index) => {
                              return (_openBlock(), _createElementBlock("td", {
                                class: "text-red",
                                key: index
                              }, _toDisplayString(_unref(formatAmount)(data)), 1))
                            }), 128)),
                            _createElementVNode("td", _hoisted_23, _toDisplayString(_unref(formatAmount)(_ctx.planMensuel['totals']['_DEPENSES_MENSUELS_'])), 1)
                          ]),
                          _createElementVNode("tr", _hoisted_24, [
                            _cache[18] || (_cache[18] = _createElementVNode("td", { class: "font-semibold text-blue text-left py-4 pl-5" }, "Crédit Epargne", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planMensuel.data['_CREDIT_EPARGNE_'], (data, index) => {
                              return (_openBlock(), _createElementBlock("td", {
                                class: "font-semibold text-blue",
                                key: index
                              }, _toDisplayString(_unref(formatAmount)(data)), 1))
                            }), 128)),
                            _createElementVNode("td", _hoisted_25, _toDisplayString(_unref(formatAmount)(_ctx.planMensuel['totals']['_CREDIT_EPARGNE_'])), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[19] || (_cache[19] = _createElementVNode("td", { class: "font-semibold text-left py-5 pl-5" }, "Solde Total Cash Flow", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planMensuel.data['_SOLDE_TOTAL_CASHFLOW_'], (data, index) => {
                              return (_openBlock(), _createElementBlock("td", {
                                class: "font-semibold",
                                key: index
                              }, _toDisplayString(_unref(formatAmount)(data)), 1))
                            }), 128)),
                            _cache[20] || (_cache[20] = _createElementVNode("td", { class: "font-semibold pr-5" }, null, -1))
                          ]),
                          _createElementVNode("tr", _hoisted_26, [
                            _cache[21] || (_cache[21] = _createElementVNode("td", { class: "text-lg font-semibold text-green text-left py-5 pl-5" }, "Utilisation By Index", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planMensuel.data['_UTILISATION_BY_INDEX_'], (data, index) => {
                              return (_openBlock(), _createElementBlock("td", {
                                class: "text-lg font-semibold text-green",
                                key: index
                              }, _toDisplayString(_unref(formatAmount)(data)), 1))
                            }), 128)),
                            _createElementVNode("td", _hoisted_27, _toDisplayString(_unref(formatAmount)(_ctx.planMensuel['totals']['_UTILISATION_BY_INDEX_'])), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[22] || (_cache[22] = _createElementVNode("td", { class: "text-lg font-semibold text-blue text-left py-5 pl-5" }, "Progressive", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planMensuel.data['_PROGRESSIVE_'], (data, index) => {
                              return (_openBlock(), _createElementBlock("td", {
                                class: "text-lg font-semibold text-blue",
                                key: index
                              }, _toDisplayString(_unref(formatAmount)(data)), 1))
                            }), 128)),
                            _cache[23] || (_cache[23] = _createElementVNode("td", { class: "text-lg font-semibold text-blue pr-5" }, null, -1))
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
    ]),
    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1))
  ], 64))
}
}

})